'use es6';

import { map } from 'rxjs/operators/map';
import http from 'hub-http/clients/apiClient';
import getEarlyRequesterResultPromise from 'content-detail-ui/earlyRequester/getEarlyRequesterResultPromise';
const URI = 'cos-domains/v1/domains/settings';
const parseDomain = (domains, domainName) => {
  const domain = domains.objects.find(d => d.domain === domainName);
  const isAnyDomainExternal = domains.objects.some(d => d.isInternalDomain === false);
  return domain ? Object.assign({}, domain, {
    isAnyDomainExternal
  }) : null;
};
export default {
  fetchDomain(currentDomain) {
    return getEarlyRequesterResultPromise({
      name: 'fetch-domains',
      retryRequester: () => http.get(URI)
    }).pipe(map(domains => parseDomain(domains, currentDomain)));
  }
};